package amazon.lastmile.inject

import app.nestbridge.feature.invitations.service.DefaultTeamMembershipUpdater
import app.nestbridge.feature.invitations.service.TeamMembershipUpdater
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = DefaultTeamMembershipUpdater::class)
public interface AppNestbridgeFeatureInvitationsServiceDefaultTeamMembershipUpdater {
  @Provides
  public fun provideDefaultTeamMembershipUpdaterTeamMembershipUpdater(defaultTeamMembershipUpdater: DefaultTeamMembershipUpdater): TeamMembershipUpdater = defaultTeamMembershipUpdater
}
